import * as React from 'react';
import styled from 'styled-components';
import { CardLinkWrapper } from './CardWrapper';
import { Image } from '../ui/ImageContain';
import { Maybe } from '../../../client/types/generated/types';
import { Link } from 'react-router-dom';
import { isExternalURL } from '../../utils/helpers/url';

export const CustomerCard: React.FC<{
  title: string;
  ingress?: Maybe<string | undefined>;
  image?: Maybe<string | undefined>;
  url?: Maybe<string | undefined>;
  style?: any;
}> = ({ title, ingress, image, url, style }) => {
  if (title && title.length > 0) {
    return (
      <LinkWrapper>
        <Container style={style}>
          {image ? (
            <Image url={isExternalURL(image).link} style={null} />
          ) : null}
          {title && !image ? <h2>{title}</h2> : null}
          {ingress ? (
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: ingress }}
            />
          ) : null}
        </Container>
      </LinkWrapper>
    );
  }

  return null;
};

const Container = styled.div`
  width: 100%;

  :not(:last-child) {
    padding-bottom: 10px;
  }
  h2 {
    color: #e8c893;
  }

  .text {
    color: white;
    padding-left: 3em;
    padding-right: 3em;
    align-items: center;
    max-width: 600px;
    margin: 1.5em auto 0 auto;

    @media all and (max-width: 600px) {
      padding-left: 0;
      padding-right: 0;
      margin: 15px auto 0 auto;
    }

    p {
      :first-child {
        margin-top: 0;
      }

      :last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const LinkWrapper = styled.div`
  position: relative;
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  background-color: white;
  max-width: 540px;
  height: 270px;
`;
